var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "p",
    {
      staticClass: "cms-post-excerpt",
      style: { textAlign: _vm.align || "left" },
    },
    [_vm._v(_vm._s(_vm.excerpt))]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }